module.exports = __webpack_public_path__ + "static/media/26_VTA - Silicon Valley.e8b2c69b.jpg";